import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { NextBestActionObj } from "../../utils/types";

const initialState: NextBestActionObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getNextBestActionData = createAsyncThunk(
  "loans/getNextBestAction",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const nextBestActionSlice = createSlice({
  name: "nextBestAction",
  initialState,
  reducers: {
    // synchronous operations go here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNextBestActionData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNextBestActionData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getNextBestActionData.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default nextBestActionSlice.reducer;
